import { useState, useEffect } from "react";
import "./QuemSomos.css";
import Imagens from "../../components/IMAGESCOMPONENT/ImageComponent";
import Navbar from "../../components/parts/navbar/Navbar";
import TopLinks from "../../components/parts/TopLinks/TopLinks";
import Menu from "../../components/parts/menu/Menu";
import Footer from "../../components/parts/footer/Footer";
import BTNtoTop from "../../components/parts/BTNtoTop/BTNtoTop";

export default function QuemSomos() {
  const [menuOpen, setMenuOpen] = useState(false);


  useEffect(() => {
      window.scrollTo({ top: 0 });
    }, []);

  return (
    <>
      <Navbar />
      <TopLinks onOpenMenu={() => setMenuOpen(true)} />
      <Menu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />


      {/* CONTEÚDO */}
      <section className="representantes-content">
        <div className="content-wrapper">
          <div className="content-image">
            <img src={Imagens.Eliandro} alt="Grupo Delly's" />
          </div>

          <div className="content-text">
            <h2>Eliandro Alimentos</h2>

            <p>
              Fundada em 2015, a Delly’s conta com portfólio de mais de 20.000 produtos, com soluções completas para food services e também para o varejo. Incluindo marcas próprias e exclusivas de vários segmentos com produtos de alta qualidade.
            </p>
            <p>
              Fundada em 2015, a Delly’s conta com portfólio de mais de 20.000 produtos, com soluções completas para food services e também para o varejo. Incluindo marcas próprias e exclusivas de vários segmentos com produtos de alta qualidade.
            </p>
            <p>
              Fundada em 2015, a Delly’s conta com portfólio de mais de 20.000 produtos, com soluções completas para food services e também para o varejo. Incluindo marcas próprias e exclusivas de vários segmentos com produtos de alta qualidade.
            </p>

            
           
          </div>
        </div>
      </section>

    
    <section className="representantes-content">
        <div className="content-wrapper">
          

          <div className="content-text">
            <h2>Centro de distribuição</h2>

            <p>
Como maior distribuidora do país, a Delly’s possui infraestrutura robusta para atender aos clientes de forma eficiente. São 17 centros de distribuição estrategicamente localizados e 22 pontos de cross docking. Composta por 1.520 veículos, entre próprios e terceirizados, a frota atende a mais de 190.000 clientes em mais de 2.600 municípios.            </p>
            <p>
              Fundada em 2015, a Delly’s conta com portfólio de mais de 20.000 produtos, com soluções completas para food services e também para o varejo. Incluindo marcas próprias e exclusivas de vários segmentos com produtos de alta qualidade.
            </p>
            <p>
              Fundada em 2015, a Delly’s conta com portfólio de mais de 20.000 produtos, com soluções completas para food services e também para o varejo. Incluindo marcas próprias e exclusivas de vários segmentos com produtos de alta qualidade.
            </p>

            
           
          </div>
<div className="content-image">
            <img src={Imagens.Eliandro2} alt="Grupo Delly's" />
          </div>

        </div>
      </section>

<div className="content-image">
            <img src={Imagens.Cidades} alt="Grupo Delly's" />
          </div>

      <BTNtoTop />

      <Footer />
    </>
  );
}
